"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styleRoutes = void 0;
exports.styleRoutes = [
    {
        name: 'style.list',
        path: ['/', '/q/:q'],
        method: 'GET'
    },
    {
        name: 'style.create',
        path: ['/'],
        method: 'POST'
    },
    {
        name: 'style.get',
        path: '/:id',
        method: 'GET'
    },
    {
        name: 'style.update',
        path: '/:id',
        method: 'PUT'
    },
    {
        name: 'style.delete',
        path: '/:id',
        method: 'DELETE'
    }
];
